import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_JOB } from '../job';

const MUTATION = gql`
  mutation IntegrationAssetsSearch(
    $filter: SearchObjectEnum!
    $dataSource: IntegrationDataSourceEnum!
    $searchTerm: String
    $customerId: ID!
    $workspaceId: ID!
  ) {
    integrationAssetsSearch(
      filter: $filter
      dataSource: $dataSource
      searchTerm: $searchTerm
      customerId: $customerId
      workspaceId: $workspaceId
    ) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

export const integrationAssetsSearch = ({
  dataSource,
  filter,
  searchTerm,
  customerId,
  workspaceId,
}) => {
  return executeGqlMutation({
    variables: { dataSource, filter, searchTerm, customerId, workspaceId },
    mutation: MUTATION,
  }).then(({ data }) => getSingleProp(data));
};
